import {
  DELETE_CAMPAIGN_SUPERADMIN,
  DELETE_CAMPAIGN_SUPERADMIN_FAILURE,
  DELETE_CAMPAIGN_SUPERADMIN_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const deleteCampaignReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_CAMPAIGN_SUPERADMIN:
      return { ...state, loading: true };
    case DELETE_CAMPAIGN_SUPERADMIN_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case DELETE_CAMPAIGN_SUPERADMIN_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteCampaignReducer;
